import React from "react";
//import uploadFile from "../../components/uploadFile";
function Admin() {
  return <h5>Admin soy</h5>;
}

export default Admin;
